<template>
  <div class="role_settings">
    <!--用户设置头部-->
    <div class="role_settings_top">
      <div><input type="text" v-model.trim="roleName" title="名称" placeholder="名称"></div>
      <button class="btn_normal w116 mr20" @click="queryData()">查询</button>
      <button class="btn_normal w116" @click="ctrlBtn('addRole', null)">新增角色</button>
    </div>

    <!--用户设置信息-->
    <div class="role_settings_msg">
      <!--表格-->
      <table class="table">
        <thead>
        <tr>
          <th>名称</th>
          <th>？启用</th>
          <th>编辑时间</th>
          <th>编辑人</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <!--v-for="(item, index) in roleList" :key="index"-->
        <tr v-for="(item, index) in roleList" :key="index">
          <td>{{item.Name}}</td>
          <td>{{item.Status | status}}</td>
          <td>{{item.CreateTime | time}}</td>
          <td>{{item.CreaterName}}</td>
          <td>
            <div>
              <a class="fcLinkA" title="配置权限" @click="ctrlBtn('configurePermissions', item)">配置权限</a>
              <a class="fcLinkA" title="编辑" @click="ctrlBtn('modifyRole', item)">编辑</a>
              <a class="fcLinkA" v-if="item.Status === 2" title="启用" @click="ctrlBtn('enableRole', item)">启用</a>
              <a class="fcLinkA" v-if="item.Status === 2" title="删除" @click="ctrlBtn('delRole', item)">删除</a>
              <a class="fcLinkA" v-if="item.Status === 1" title="停用" @click="ctrlBtn('disableRole', item)">停用</a>
            </div>
          </td>
        </tr>
        </tbody>
        <tbody v-if="!roleList.length">
        <tr>
          <td colspan="5">暂时没有相关的数据</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div class="text_right mt20">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <role-settings-embed-msg v-if="isShow" :title="dialogTitle" :roleMsg="userMsg"
                         :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></role-settings-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script type="es6">
  import RoleSettingsEmbedMsg from './role-settings-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'role-settings',
    components: {RoleSettingsEmbedMsg, MsgDialog, LoadingDialog},
    data() {
      return {
        roleList: [], // 角色列表
        roleName: '', // 角色名称
        userMsg: null, // 用户(角色)信息
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      // 根据角色名称查询角色分页
      queryData() {
        this.currentPage = 1;
        this.getRoleList();
      },

      // 获取角色分页数据
      getRoleList() {
        this.isLoading = true;
        const params = {
          RoleName: this.roleName,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.getRoleList, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res.data) {
              if (!res.data.errorMsg.length) {
                self.roleList = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
                /* self.$router.push({
                  path: '/home/r_setup',
                  query: {
                    roleName: this.roleName,
                    currentPage: this.currentPage,
                    pageSize: this.pageSize
                  }
                }); */
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
                self.roleList = [];
                self.total = 0;
              }
            }
          }, 500);

          this.Global.tabsChange(this.$route, '角色设置');
        });
      },

      // 操作按钮
      ctrlBtn(type, userMsg) {
        this.isShow = true;
        this.dialogShowType = type;
        this.userMsg = userMsg;
        switch (type) {
          case 'addRole':
            this.dialogTitle = '新增角色';
            break;
          case 'modifyRole':
            this.dialogTitle = '编辑角色';
            break;
          case 'configurePermissions':
            this.dialogTitle = '配置权限';
            break;
          case 'disable':
            this.dialogTitle = '提示';
            break;
        }
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          this.getRoleList();
        }
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        // 当前页面显示条数改变重新获取店铺分页数据
        this.getRoleList();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        // 当前页改变重新获取店铺分页数据
        this.getRoleList();
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.getRoleList();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.roleList = [];
        this.roleName = '';
        this.isShow = false;
        this.currentPage = 1;
        this.pageSize = 10;
        this.total = 0;
        this.getRoleList();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/base-color";
  @import "../../../assets/css/home-view";

  .table {
    td {
      div {
        display: inline-block;
        width: 182px;
        margin: auto;
        text-align: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/system-based/role-settings.vue